import { ReactNode } from "react";
import AuthGuard from "./AuthGuard";
import { RequireAdminRole } from "./RequireAdminRole";

interface AdminRouteProps {
  children: ReactNode;
  fallbackPath?: string;
  requireMessage?: string;
}

/**
 * AdminRoute - Combined authentication and authorization guard for admin routes
 *
 * Provides two layers of protection:
 * 1. AuthGuard - Ensures user is authenticated (redirects to login if not)
 * 2. RequireAdminRole - Ensures user has admin privileges (shows access denied if not)
 *
 * Usage:
 * <Route path="/backend-admin">
 *   <AdminRoute>
 *     <BackendAdmin />
 *   </AdminRoute>
 * </Route>
 */
export function AdminRoute({
  children,
  fallbackPath = "/login",
  requireMessage = "Admin access required to view this page",
}: AdminRouteProps) {
  return (
    <AuthGuard fallbackPath={fallbackPath}>
      <RequireAdminRole fallbackMessage={requireMessage}>
        {children}
      </RequireAdminRole>
    </AuthGuard>
  );
}

export default AdminRoute;
